import React from 'react'
import { graphql, Link } from 'gatsby'

import Layout from '../components/layout/layout'

import Breadcrumb from '../components/breadcrumb/breadcrumb'
import Carousel from '../components/carousel/carousel'
import EventsTable from '../components/events/events-table'
import SEO from '../components/seo'

import EggSausageChipsBeansRemixCarouselItem from '../components/carousel-items/egg-sausage-chips-beans-remix'
import TourDeSauceCarouselItem from '../components/carousel-items/tour-de-sauce'

const IndexPage = ({ data }) => {
  const events = data.allMarkdownRemark.edges

  return (
    <>
      <SEO />

      <Layout>
        <Breadcrumb />

        <div className='row'>
          <div className='col mb-4'>
            <h4 className='bg-danger text-light p-2'>News</h4>

            <Carousel id='homepageCarousel' fade>
              <TourDeSauceCarouselItem active />
              <EggSausageChipsBeansRemixCarouselItem />
            </Carousel>

            <Link to='/news/' className='btn btn-link btn-block mt-2'>
              All news
            </Link>
          </div>
        </div>

        <div className='row'>
          <div className='col mb-2'>
            <h4 className='bg-danger text-light p-2'>Events</h4>

            <EventsTable events={events} type='upcoming' limit={5} />

            <Link to='/events/' className='btn btn-link btn-block mt-2'>
              All events
            </Link>
          </div>
        </div>
      </Layout>
    </>
  )
}

export default IndexPage

export const query = graphql`
  {
    allMarkdownRemark(
      filter: { fields: { collection: { eq: "events" } } }
      sort: { fields: frontmatter___datetime, order: ASC }
    ) {
      totalCount
      edges {
        node {
          id
          fields {
            slug
          }
          frontmatter {
            datetime
            status
            ticketURL
            type
            tour {
              frontmatter {
                tourId
              }
            }
            venue {
              frontmatter {
                venueId
                displayName
                address {
                  street
                  locality
                  region
                  postcode
                }
                email
                telephone
                websiteURL
              }
            }
          }
        }
      }
    }
  }
`
